/**
 * @module Login Form Action
 */

import {setTimeout} from '@acng/frontend-bounty/dom/window.js';
import {IS, guard} from '@acng/frontend-rubicon';
import {AttributeLink} from '@acng/frontend-stargazer';

import {iOS} from 'acng/core/constant/iOS';
import {inject} from 'acng/core/service/ng.js';
import {onSubmit} from 'acng/layout/service/worker.js';
import {valid, login} from '../service/login.js';
import {assign} from 'acng/core/service/location.js';

/**
 * @group DOM Attribute
 */
const attributeName = 'action-login';

AttributeLink(attributeName, (form, value) => {
  ASSERT: guard(form, IS(HTMLFormElement));

  const overlay = inject('onsOverlay').get('pageLogin');

  if (!iOS && overlay) {
    setTimeout(() => {
      ASSERT: guard(form.login, IS(HTMLInputElement));

      form.login.focus();
    });
  }

  return () =>
    onSubmit(form, async (form, data) => {
      ASSERT: valid(data);

      const authUser = await login(form, data);

      if (authUser && value) {
        assign(form, value);
      }
    });
});
